<script>
	import ExerciseBankSidebar from './ExerciseBankSidebar.svelte';
	import { push } from 'svelte-spa-router';

	// Statistics data structure
	const stats = [
		{ label: 'Užduotys', value: '1,234', icon: 'book-open' },
		{ label: 'Aktyvūs mokiniai', value: '856', icon: 'users' },
		{ label: 'Išspręsta šią savaitę', value: '2,451', icon: 'trending-up' },
	];

	let activePage = 'pradzia';
	let searchQuery = '';

	function handlePageChange(pageId) {
		if (pageId === 'ikelti') {
			// Navigate to upload exercise page
			push('/exercise-bank/upload');
		} else if (pageId === 'uzduociu-bankas') {
			// Navigate to exercise bank page
			push('/exercise-bank/bank');
		} else {
			activePage = pageId;
		}
	}

	// Icon components as SVG strings (for stats and search)
	const icons = {
		'book-open': `<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>`,
		search: `<circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.35-4.35"></path>`,
		users: `<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>`,
		'trending-up': `<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline>`,
	};
</script>

<div class="app-container">
	<!-- Sidebar -->
	<ExerciseBankSidebar {activePage} onPageChange={handlePageChange} />

	<!-- Main Content -->
	<main class="main-content">
		{#if activePage === 'pradzia'}
			<div class="home-container">
				<!-- Hero Section -->
				<div class="hero-section">
					<h1 class="hero-title">Sveiki atvykę į Užduočių Banką</h1>
					<p class="hero-description">
						Raskite ir spręskite užduotis iš įvairių dalykų. Pasiruoškite egzaminams
						ir tobulėkite savo tempiu.
					</p>

					<!-- Search Bar -->
					<div class="search-container">
						<svg
							class="search-icon"
							width="20"
							height="20"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							{@html icons.search}
						</svg>
						<input
							type="text"
							class="search-input"
							placeholder="Ieškokite užduočių pagal temą ar dalyką..."
							bind:value={searchQuery}
						/>
					</div>
				</div>

				<!-- Stats Cards -->
				<div class="stats-grid">
					{#each stats as stat}
						<div class="stat-card">
							<div class="stat-content">
								<div class="stat-icon-wrapper">
									<svg
										class="stat-icon"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
									>
										{@html icons[stat.icon]}
									</svg>
								</div>
								<div class="stat-info">
									<div class="stat-label">{stat.label}</div>
									<div class="stat-value">{stat.value}</div>
								</div>
							</div>
						</div>
					{/each}
				</div>

				<!-- Quick Actions -->
				<div class="quick-actions">
					<h2 class="quick-actions-title">Pradėkite dabar</h2>
					<div class="quick-actions-grid">
						<button class="action-button">
							<div class="action-content">
								<div class="action-title">Naršyti užduotis</div>
								<div class="action-description">
									Raskite užduotis pagal dalyką ir temą
								</div>
							</div>
						</button>
						<button class="action-button">
							<div class="action-content">
								<div class="action-title">Bandomieji egzaminai</div>
								<div class="action-description">
									Pasitikrinkite žinias su bandomaisiais testais
								</div>
							</div>
						</button>
					</div>
				</div>
			</div>
		{/if}
	</main>
</div>

<style>
	.app-container {
		display: flex;
		height: 100vh;
		background-color: #f9fafb;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100vw;
		z-index: 1000;
	}

	/* Main Content Styles */
	.main-content {
		flex: 1;
		overflow: auto;
	}

	.home-container {
		max-width: 1280px;
		margin: 0 auto;
		padding: 48px 32px;
	}

	/* Hero Section */
	.hero-section {
		text-align: center;
		margin-bottom: 64px;
	}

	.hero-title {
		color: #111827;
		font-size: 32px;
		font-weight: 700;
		margin: 0 0 16px 0;
	}

	.hero-description {
		color: #4b5563;
		max-width: 672px;
		margin: 0 auto 32px;
		font-size: 16px;
		line-height: 1.5;
	}

	.search-container {
		max-width: 576px;
		margin: 0 auto;
		position: relative;
	}

	.search-icon {
		position: absolute;
		left: 16px;
		top: 50%;
		transform: translateY(-50%);
		color: #9ca3af;
		pointer-events: none;
	}

	.search-input {
		width: 100%;
		padding: 12px 16px 12px 48px;
		height: 48px;
		border: 1px solid #d1d5db;
		border-radius: 8px;
		font-size: 14px;
		font-family: inherit;
		background-color: white;
		box-sizing: border-box;
	}

	.search-input:focus {
		outline: none;
		border-color: #fab45a;
		box-shadow: 0 0 0 3px rgba(250, 180, 90, 0.1);
	}

	/* Stats Grid */
	.stats-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
		gap: 24px;
		margin-bottom: 64px;
	}

	.stat-card {
		background-color: white;
		border-radius: 8px;
		padding: 24px;
		border: 1px solid #e5e7eb;
	}

	.stat-content {
		display: flex;
		align-items: center;
		gap: 16px;
	}

	.stat-icon-wrapper {
		width: 48px;
		height: 48px;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #fff7ed;
	}

	.stat-icon {
		color: #fab45a;
	}

	.stat-info {
		flex: 1;
	}

	.stat-label {
		color: #4b5563;
		font-size: 14px;
		margin-bottom: 4px;
	}

	.stat-value {
		color: #111827;
		font-size: 20px;
		font-weight: 600;
	}

	/* Quick Actions */
	.quick-actions {
		background-color: white;
		border-radius: 8px;
		padding: 32px;
		border: 1px solid #e5e7eb;
	}

	.quick-actions-title {
		color: #111827;
		font-size: 20px;
		font-weight: 600;
		margin: 0 0 24px 0;
	}

	.quick-actions-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
		gap: 16px;
	}

	.action-button {
		height: auto;
		padding: 16px;
		text-align: left;
		border: 1px solid #e5e7eb;
		border-radius: 8px;
		background-color: white;
		cursor: pointer;
		transition: all 0.2s ease;
		font-family: inherit;
	}

	.action-button:hover {
		border-color: #fab45a;
		background-color: #fff7ed;
	}

	.action-content {
		text-align: left;
	}

	.action-title {
		color: #111827;
		font-size: 16px;
		font-weight: 500;
		margin-bottom: 4px;
	}

	.action-description {
		color: #4b5563;
		font-size: 14px;
	}

	/* Responsive Design */
	@media (max-width: 768px) {
		.app-container {
			flex-direction: column;
		}

		.home-container {
			padding: 24px 16px;
		}

		.hero-title {
			font-size: 24px;
		}

		.stats-grid {
			grid-template-columns: 1fr;
		}

		.quick-actions-grid {
			grid-template-columns: 1fr;
		}
	}
</style>
